export default __webpack_public_path__ + "static/media/gallery_04.1317a075.jpg";